import { render, staticRenderFns } from "./footer_contact.vue?vue&type=template&id=36d13aaf&scoped=true&"
import script from "./footer_contact.vue?vue&type=script&lang=js&"
export * from "./footer_contact.vue?vue&type=script&lang=js&"
import style0 from "./footer_contact.vue?vue&type=style&index=0&id=36d13aaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d13aaf",
  null
  
)

export default component.exports